import React from 'react';
import { AlertTriangle, CreditCard, Loader2 } from 'lucide-react';
import './CreditLimitSection.scss';

const CreditLimitSection = ({ 
  creditLimit = 0, 
  utilizedLimit = 0,
  billingMode = 'Postpaid',
  creditNote = '',
  loading = false,
  error = null,
  branchId,
  hospitalName,
  branchName,
  isNewBranch
}) => {

  // Calculate derived values
  const availableCredit = utilizedLimit < 0 ? 0 : Math.max(0, creditLimit - utilizedLimit);
  console.log("availableCredit", availableCredit)
  // const utilizationPercentage = creditLimit > 0 ? (utilizedLimit / creditLimit) * 100 : 0;
  // const utilizationPercentage =
  //   creditLimit > 0
  //     ? Math.min(((utilizedLimit / creditLimit) * 100).toFixed(2), 100)
  //     : 0;
  const utilizationPercentage =
    creditLimit > 0
      ? Math.max(
          0,
          Math.min(((utilizedLimit / creditLimit) * 100).toFixed(2), 100)
        )
      : 0;


  console.log("utilizationPercentage", utilizationPercentage)
  // const isThresholdReached = utilizationPercentage >= (creditThresholdPercent || 85);

  return (
    <div className="credit-limit">
      <div className="credit-limit__header">
        <CreditCard className="credit-limit__icon" />
        <h2 className="credit-limit__title">₹ Spend vs Credit Limit</h2>
      </div>
      
      <p className="credit-limit__subtitle">Current credit utilization</p>

      {/* Warning Section */}
      {utilizationPercentage.toFixed(1)>85   && 
      <div className="credit-limit__warning">
        <div className="credit-limit__warning-content">
          <AlertTriangle className="credit-limit__warning-icon" />
          </div>
          <div>
            <h3 className="credit-limit__warning-title">High Utilization Warning</h3>
            <p className="credit-limit__warning-text">
              Credit utilization is {utilizationPercentage.toFixed(1)}%. Consider reviewing spending.
            </p>
          {/* </div> */}
        </div>
      </div>
      }
      {/* Progress Bar */}
      <div className="credit-limit__progress-section">
        <div className="credit-limit__progress-header">
          <span className="credit-limit__progress-label">Credit Utilization</span>
          <span className="credit-limit__progress-percentage">{utilizationPercentage.toFixed(1)}%</span>
        </div>
        <div className="credit-limit__progress-bar">
          <div 
            className="credit-limit__progress-fill"
            style={{ width: `${utilizationPercentage}%` }}
          ></div>
        </div>
        <div className="credit-limit__progress-markers">
          <span>0%</span>
          <span>50%</span>
          <span>100%</span>
        </div>
      </div>

      {/* Spend Details */}
      <div className="credit-limit__details">
        <div className="credit-limit__detail-row">
          <span className="credit-limit__detail-label">Credit Limit</span>
          <span className="credit-limit__detail-value">₹{creditLimit?.toLocaleString('en-IN')}</span>
        </div>
        <div className="credit-limit__detail-row">
          <span className="credit-limit__detail-label">Credit Utilised</span>
          <span className="credit-limit__detail-value">₹{utilizedLimit?.toLocaleString('en-IN')}</span>
        </div>
        <div className="credit-limit__detail-row">
          <span className="credit-limit__detail-label">Remaining Credit</span>
          <span className="credit-limit__detail-value credit-limit__detail-value--green">₹{availableCredit?.toLocaleString('en-IN')}</span>
        </div>
        {/* <hr className="credit-limit__divider" /> */}
        <div className="credit-limit__detail-row">
          <span className="credit-limit__detail-label">Payment Mode</span>
          <span className="credit-limit__detail-value">
            {billingMode ? `${billingMode.charAt(0).toUpperCase()}${billingMode.slice(1).toLowerCase()}` : 'Postpaid'}
          </span>
        </div>
      </div>
      
    </div>
  );
};

export default CreditLimitSection;